// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ftod","index":"styles_index__uwdka"};